import packageJson from '../../../../package.json';

import { config } from '../../../config.json';

export function DisplayVersion(): any {
	if (config.environment === 'PROD') return '';

	return <p>Versão: {packageJson.version}</p>;
}
